import { PickPoint } from '@pnext/three-loader';
import { atom } from 'jotai';

export const pickedPointAtom = atom<(PickPoint & { screenX: number; screenY: number; cameraAngle: number }) | null>(
  null,
);
